import { toastr } from 'react-redux-toastr';
import ReactGA from 'react-ga4';
import AuthHelper from '../../utils/authHelper';
import posthog from 'posthog-js';

export const LOGIN_REQUEST = 'auth/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE';
export const LOGOUT = 'auth/LOGOUT';
export const GET_USER_INFO_REQUEST = 'auth/GET_USER_INFO_REQUEST';
export const GET_USER_INFO_SUCCESS = 'auth/GET_USER_INFO_SUCCESS';
export const SIGNUP_REQUEST = 'auth/SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'auth/SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'auth/SIGNUP_FAILURE';
export const GET_ALL_USERS_REQUEST = 'auth/GET_ALL_USERS_REQUEST';
export const GET_ALL_USERS_SUCCESS = 'auth/GET_ALL_USERS_SUCCESS';
export const LOGIN_MFA_REQUIRED = 'auth/LOGIN_MFA_REQUIRED';
export const LOGIN_MFA_FAILURE = 'auth/LOGIN_MFA_FAILURE';
export const RESET_LOGIN_MFA = 'auth/RESET_LOGIN_MFA';
export const LOGIN_RESET_PASSWORD = 'auth/LOGIN_RESET_PASSWORD';

export const login = (username, password) => (dispatch) => {
  dispatch({ type: LOGIN_REQUEST });
  return AuthHelper.login(username, password)
    .then((res) => {
      if (res.data?.mfa_required) {
        dispatch({
          type: LOGIN_MFA_REQUIRED,
          payload: { username },
        });
      } else if (res.data?.reset_token) {
        dispatch({
          type: LOGIN_RESET_PASSWORD,
          payload: res.data,
        });
      }

      posthog.identify(username);
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      toastr.error('Login Failed!', 'Username or password is invalid.');
      dispatch({
        type: LOGIN_FAILURE,
      });
    });
};

export const verifyLoginMFA = (code) => (dispatch) => {
  dispatch({ type: LOGIN_REQUEST });
  return AuthHelper.loginVerifyMFA(code)
    .then((res) => {
      posthog.identify(res.data?.user?.username);
      dispatch({
        type: LOGIN_SUCCESS,
        payload: res.data,
      });
    })
    .catch(() => {
      toastr.error(
        'MFA Verification Failed',
        'Please check the code and try again.',
      );
      dispatch({
        type: LOGIN_MFA_FAILURE,
      });
      throw new Error('MFA verification failed');
    });
};

export const resetLoginMFA = () => ({
  type: RESET_LOGIN_MFA,
});

export const logout = () => {
  posthog.reset(true);
  AuthHelper.logout();
  return {
    type: LOGOUT,
  };
};

export const getUserInfo = () => (dispatch) => {
  dispatch({ type: GET_USER_INFO_REQUEST });
  return AuthHelper.getUserInfo()
    .then((res) => {
      ReactGA.set({ dimension1: 'AD' + res.data.id });
      dispatch({
        type: GET_USER_INFO_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: LOGOUT,
      });
    });
};

export const getAllUsers = () => (dispatch) => {
  dispatch({ type: GET_ALL_USERS_REQUEST });
  return AuthHelper.getAllUsers()
    .then((res) => {
      dispatch({
        type: GET_ALL_USERS_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {});
};

export const signup = (email, username, password) => (dispatch) => {
  dispatch({ type: SIGNUP_REQUEST });
  return AuthHelper.signup(email, username, password)
    .then((res) => {
      dispatch({
        type: SIGNUP_SUCCESS,
        payload: res.data,
      });
      toastr.success('Success!', 'Account created successfully.');
    })
    .catch((err) => {
      dispatch({
        type: SIGNUP_FAILURE,
      });
      throw err;
    });
};
